module.exports = __webpack_public_path__ + "img/Arrow_down.0a187599.svg";